var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8GasMask50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0277BD",
    d: "M5 21H43V25H5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#03A9F4",
    d: "M31,39H17c-4.4,0-8-3.6-8-8V18C9,9.7,15.7,3,24,3l0,0c8.3,0,15,6.7,15,15v13C39,35.4,35.4,39,31,39z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B3E5FC",
    d: "M31 19A4 4 0 1 0 31 27 4 4 0 1 0 31 19zM17 19A4 4 0 1 0 17 27 4 4 0 1 0 17 19z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#607D8B",
    d: "M24,31c-4,0-7,3-7,7s3,7,7,7s7-3,7-7S28,31,24,31z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M24 33c-.6 0-1 .4-1 1s.4 1 1 1c.6 0 1-.4 1-1S24.6 33 24 33zM24 41c-.6 0-1 .4-1 1s.4 1 1 1c.6 0 1-.4 1-1S24.6 41 24 41zM19.7 35.5c-.3.5-.1 1.1.4 1.4.5.3 1.1.1 1.4-.4s.1-1.1-.4-1.4C20.5 34.9 20 35 19.7 35.5zM26.6 39.5c-.3.5-.1 1.1.4 1.4.5.3 1.1.1 1.4-.4.3-.5.1-1.1-.4-1.4C27.5 38.9 26.9 39 26.6 39.5zM19.7 40.5c.3.5.9.6 1.4.4.5-.301.6-.9.4-1.4s-.9-.6-1.4-.4C19.5 39.4 19.4 40 19.7 40.5zM26.6 36.5c.301.5.9.6 1.4.4.5-.301.6-.9.4-1.4C28 35 27.5 34.9 27 35.1 26.5 35.4 26.3 36 26.6 36.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8GasMask50);
export default __webpack_public_path__ + "static/media/icons8-gas-mask-50.ab59fced1f0ec09c12a242a2d98b1209.svg";
export { ForwardRef as ReactComponent };